const sat = {
  tr: {
    satList: {
      tabs: {
        mine: "Sırası bende",
        open: "Devam eden",
        pending: "Onay bekleyen",
        completed: "Tamamlanan",
        closed: "Reddedilen / İptal",
        all: "Tümü",
      },
      filters: {
        search: "Başlık, kod veya talep eden ara...",
        searchMine: "Başlık veya kod ara...",
        allCategories: "Tüm kategoriler",
        allPriorities: "Tüm öncelikler",
        allStages: "Tüm aşamalar",
        from: "Talep tarihi ≥",
        to: "Talep tarihi ≤",
        sort: "Sırala",
        sortNewest: "Yeni → eski",
        sortOldest: "Eski → yeni (en uzun bekleyen)",
        sortPriority: "Öncelik (yüksek → düşük)",
        sortPriceDesc: "Tutar (yüksek → düşük)",
        sortPriceAsc: "Tutar (düşük → yüksek)",
      },
      emptyFiltered: "Bu görünümde talep yok.",
      waiting: "gündür bekliyor",
      waitingToday: "bugün geldi",
      refresh: "Yenile",
      back: "Geri",
      mineHint: "Onayınızı bekleyen talepler",
      actionFailed: "İşlem başarısız",
      dismiss: "Kapat",
    },
    satReportUi: {
      open: "Açık",
      plan: "Plan (TL)",
      actual: "Gerçekleşen (TL)",
      diff: "Fark (TL)",
    },
    applications: {
      title: "Başvurular",
      subtitle:
        "BTO web sitesinden gelen iş başvuruları. Statü değiştirin, etiketleyin ve CV indirin. Onaylanan başvurular yöneticilere bildirim olarak iletilir.",
      status: { new: "Yeni", approved: "Onaylandı", pooled: "Havuza Alındı", rejected: "Reddedildi" },
      actions: { approve: "Onayla", pool: "Havuza Al", reject: "Reddet", reset: "Yeniye Çevir" },
      removeTag: "Etiketi kaldır",
      removeTagNamed: "{{name}} etiketini kaldır",
      loadFailed: "Yüklenemedi.",
      updateFailed: "Güncellenemedi.",
      saveFailed: "Kaydedilemedi.",
      deleteFailed: "Silinemedi.",
      tagAddFailed: "Etiket eklenemedi.",
      tagRemoveFailed: "Etiket silinemedi.",
      cvDownloadFailed: "CV indirilemedi.",
      rejectConfirm: "Başvuru reddedilsin mi?",
      detailAria: "Başvuru detayı #{{id}}",
      detailTitle: "Başvuru Detayı #{{id}}",
      close: "Kapat",
      loading: "Yükleniyor…",
      detail: {
        applicant: "Aday",
        email: "E-posta",
        phone: "Telefon",
        job: "İlan",
        type: "Başvuru Tipi",
        date: "Tarih",
        status: "Statü",
        cv: "CV",
        description: "Açıklama",
        tags: "Etiketler",
        history: "Geçmiş",
      },
      downloadCv: "CV indir",
      none: "(yok)",
      noHistory: "(geçmiş yok)",
      tagPlaceholder: "Etiket ekle veya mevcut etiketi seç…",
      add: "Ekle",
      update: "Güncelle",
      cancel: "İptal",
      edit: "Düzenle",
      delete: "Sil",
      editTitle: "Düzenle #{{id}}",
      changeStatus: "Statü Değiştir",
      notePlaceholder: "Not (opsiyonel)",
      approveHint: "Onaylandığında yöneticilere e-posta + bildirim gönderilir.",
      tabAll: "Tümü",
      tabActive: "Aktif",
      tabInactive: "Pasif",
      tabsAria: "Başvuru statüleri",
      forbiddenTitle: "Bu sayfaya erişim yetkiniz yok.",
      forbiddenBody:
        "Başvuruları görüntüleyebilmek için yöneticinizden applications aracı için izin talep edin (admin/it/company_manager rollerine otomatik verilir).",
      refresh: "Yenile",
      searchPlaceholder: "Ad veya e-posta ara…",
      filters: {
        typeAria: "Başvuru tipi",
        allTypes: "Tüm Tipler",
        tagAria: "Etiket",
        allTags: "Tüm Etiketler",
        from: "Başvuru ≥",
        to: "Başvuru ≤",
        sort: "Sırala",
      },
      sort: {
        createdDesc: "Başvuru tarihi (yeni → eski)",
        createdAsc: "Başvuru tarihi (eski → yeni)",
        updatedDesc: "Son güncellenen",
        nameAsc: "Ad (A → Z)",
        nameDesc: "Ad (Z → A)",
      },
      emptyFiltered: "Bu görünümde başvuru yok.",
      emptyFilteredRecords: "Bu görünümde kayıt yok.",
      empty: "Kayıt yok.",
      columns: {
        candidate: "Aday",
        job: "İlan",
        type: "Tip",
        description: "Açıklama",
        file: "Dosya",
        date: "Tarih",
        status: "Statü",
        tags: "Etiketler",
        action: "İşlem",
      },
      cvPresent: "CV mevcut",
      yes: "Evet",
      no: "Hayır",
      review: "İncele",
      types: {
        title: "Başvuru Tipleri",
        subtitle:
          "İş ilanları oluşturulurken seçilen tipler (Tam Zamanlı, Staj, Burs, vb.). Silmek yerine pasifleştirilir; geçmiş ilanlardaki referanslar bozulmaz.",
        addTitle: "Yeni Tip Ekle",
        nameTr: "Türkçe isim",
        nameEn: "İngilizce isim",
        order: "Sıra",
        active: "Aktif",
        namesRequired: "Türkçe ve İngilizce isim zorunlu.",
        deactivateConfirm: "\"{{name}}\" pasifleştirilsin mi?",
        deactivate: "Pasifleştir",
        searchPlaceholder: "Tip adı ara…",
        colTr: "Türkçe",
        colEn: "İngilizce",
      },
      tags: {
        title: "Başvuru Etiketleri",
        subtitle:
          "İnceleyenlerin kullandığı etiket havuzu. Burada ad/renk düzenleyin veya kullanılmayan etiketleri silin. Silinen etiket tüm başvurulardan kaldırılır.",
        addTitle: "Yeni Etiket Ekle",
        name: "Etiket adı",
        color: "Renk",
        colorAria: "Etiket rengi",
        nameRequired: "İsim zorunlu.",
        deleteConfirm:
          "\"{{name}}\" etiketi silinsin mi? Tüm başvurulardaki bu etiket bağı kaldırılacak.",
        searchPlaceholder: "Etiket ara…",
        sortName: "Ada göre (A → Z)",
        sortNewest: "Yeni → eski",
        sortOldest: "Eski → yeni",
        noMatch: "Aramaya uyan etiket yok.",
        colTag: "Etiket",
        colCreated: "Oluşturulma",
      },
    },
  },
  en: {
    satList: {
      tabs: {
        mine: "My turn",
        open: "In progress",
        pending: "Pending approval",
        completed: "Completed",
        closed: "Rejected / Cancelled",
        all: "All",
      },
      filters: {
        search: "Search title, code or requester...",
        searchMine: "Search title or code...",
        allCategories: "All categories",
        allPriorities: "All priorities",
        allStages: "All stages",
        from: "Requested ≥",
        to: "Requested ≤",
        sort: "Sort",
        sortNewest: "Newest first",
        sortOldest: "Oldest first (longest waiting)",
        sortPriority: "Priority (high → low)",
        sortPriceDesc: "Amount (high → low)",
        sortPriceAsc: "Amount (low → high)",
      },
      emptyFiltered: "No requests in this view.",
      waiting: "days waiting",
      waitingToday: "arrived today",
      refresh: "Refresh",
      back: "Back",
      mineHint: "Requests waiting for your approval",
      actionFailed: "Action failed",
      dismiss: "Dismiss",
    },
    satReportUi: {
      open: "Open",
      plan: "Planned (TRY)",
      actual: "Actual (TRY)",
      diff: "Difference (TRY)",
    },
    applications: {
      title: "Applications",
      subtitle:
        "Job applications received from the BTO website. Change status, tag them and download CVs. Approved applications are notified to managers.",
      status: { new: "New", approved: "Approved", pooled: "Pooled", rejected: "Rejected" },
      actions: { approve: "Approve", pool: "Add to pool", reject: "Reject", reset: "Mark as new" },
      removeTag: "Remove tag",
      removeTagNamed: "Remove tag {{name}}",
      loadFailed: "Could not be loaded.",
      updateFailed: "Could not be updated.",
      saveFailed: "Could not be saved.",
      deleteFailed: "Could not be deleted.",
      tagAddFailed: "Tag could not be added.",
      tagRemoveFailed: "Tag could not be removed.",
      cvDownloadFailed: "CV could not be downloaded.",
      rejectConfirm: "Reject this application?",
      detailAria: "Application details #{{id}}",
      detailTitle: "Application Details #{{id}}",
      close: "Close",
      loading: "Loading…",
      detail: {
        applicant: "Applicant",
        email: "Email",
        phone: "Phone",
        job: "Job posting",
        type: "Application type",
        date: "Date",
        status: "Status",
        cv: "CV",
        description: "Description",
        tags: "Tags",
        history: "History",
      },
      downloadCv: "Download CV",
      none: "(none)",
      noHistory: "(no history)",
      tagPlaceholder: "Add a tag or pick an existing one…",
      add: "Add",
      update: "Update",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      editTitle: "Edit #{{id}}",
      changeStatus: "Change Status",
      notePlaceholder: "Note (optional)",
      approveHint: "Managers receive an email and a notification when approved.",
      tabAll: "All",
      tabActive: "Active",
      tabInactive: "Inactive",
      tabsAria: "Application statuses",
      forbiddenTitle: "You do not have access to this page.",
      forbiddenBody:
        "To view applications, ask your administrator for permission to the applications tool (granted automatically to admin/it/company_manager roles).",
      refresh: "Refresh",
      searchPlaceholder: "Search name or email…",
      filters: {
        typeAria: "Application type",
        allTypes: "All types",
        tagAria: "Tag",
        allTags: "All tags",
        from: "Applied ≥",
        to: "Applied ≤",
        sort: "Sort",
      },
      sort: {
        createdDesc: "Application date (newest first)",
        createdAsc: "Application date (oldest first)",
        updatedDesc: "Recently updated",
        nameAsc: "Name (A → Z)",
        nameDesc: "Name (Z → A)",
      },
      emptyFiltered: "No applications in this view.",
      emptyFilteredRecords: "No records in this view.",
      empty: "No records.",
      columns: {
        candidate: "Applicant",
        job: "Job posting",
        type: "Type",
        description: "Description",
        file: "File",
        date: "Date",
        status: "Status",
        tags: "Tags",
        action: "Action",
      },
      cvPresent: "CV available",
      yes: "Yes",
      no: "No",
      review: "Review",
      types: {
        title: "Application Types",
        subtitle:
          "Types selected when creating job postings (Full-time, Internship, Scholarship, etc.). They are deactivated instead of deleted; references in past postings stay intact.",
        addTitle: "Add New Type",
        nameTr: "Turkish name",
        nameEn: "English name",
        order: "Order",
        active: "Active",
        namesRequired: "Turkish and English names are required.",
        deactivateConfirm: "Deactivate \"{{name}}\"?",
        deactivate: "Deactivate",
        searchPlaceholder: "Search type name…",
        colTr: "Turkish",
        colEn: "English",
      },
      tags: {
        title: "Application Tags",
        subtitle:
          "The tag pool used by reviewers. Edit names/colors here or delete unused tags. A deleted tag is removed from all applications.",
        addTitle: "Add New Tag",
        name: "Tag name",
        color: "Color",
        colorAria: "Tag color",
        nameRequired: "Name is required.",
        deleteConfirm:
          "Delete tag \"{{name}}\"? It will be removed from all applications.",
        searchPlaceholder: "Search tags…",
        sortName: "By name (A → Z)",
        sortNewest: "Newest first",
        sortOldest: "Oldest first",
        noMatch: "No tags match your search.",
        colTag: "Tag",
        colCreated: "Created",
      },
    },
  },
};

export default sat;
